/**
 * @author Fernando FH
 */

 import PRM from "@/core/PermissionConstants";
 import  RouteConstants  from "@/app/core/RouteConstants";

export default {
  path: RouteConstants.TELEMEDICINE_PAGINATION_START.path,
  name: RouteConstants.TELEMEDICINE_PAGINATION_START.name,
  component: () => import("@/app/views/crud/CrudView.vue"),
  meta: {
    service: () => import("@/app/services/TelemedicineToStartService"),
    table: () =>  import("@/app/components/telemedicine/tostart/TelemedicineToStartTable"),
    form: () =>  import("@/app/components/telemedicine/tostart/TelemedicineToStartForm"),
    header: {
      icono: "mdi-monitor-dashboard",
      texto: "Por iniciar | Telemedicina",
      textNew: "Atender  | Telemedicina",
      textEdit: "Editar  | Telemedicina",
      textView: "Visualizar  | Telemedicina"
    },
    prm: PRM.MODULE_TELEMEDICINE_PAGINATION_START,
    requireAuth: true,
    filterDate: true,
    hideButtonAdd: true,
    filterModality: true,
    cancelationModal: true,
    generatePDFModal: true,
    labelDate: "Seleccione fecha",
    namePDF: "Telemedicina",
    module: "telemedicina"
  },
};
